module.exports = __webpack_public_path__ + "static/media/WhiteDrownin.a462fb84.jpg";